/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Pit3_DInputs */

const en_to_csv_pit3_d = /** @type {(inputs: To_Csv_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The output is UTF-8 with no byte order mark. Double clicking the file on Windows makes Excel guess the system code page, which corrupts accented and CJK characters. Import through the Data then From Text dialog and choose UTF-8, or add a byte order mark first. Sheets and LibreOffice handle it correctly either way.`)
};

const ko_to_csv_pit3_d = /** @type {(inputs: To_Csv_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력은 바이트 순서 표시가 없는 UTF-8입니다. Windows에서 파일을 두 번 클릭하면 Excel이 시스템 코드 페이지를 추측하며, 악센트 문자와 한글, 한자가 손상됩니다. 데이터 다음 텍스트에서 대화상자로 가져와 UTF-8을 선택하거나, 먼저 바이트 순서 표시를 추가하세요. Sheets와 LibreOffice는 어느 쪽이든 올바르게 처리합니다.`)
};

const ja_to_csv_pit3_d = /** @type {(inputs: To_Csv_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力はバイトオーダーマークのない UTF-8 です。Windows でファイルをダブルクリックすると Excel がシステムコードページを推測し、アクセント付き文字や日本語が壊れます。データからテキストのダイアログで取り込み UTF-8 を選ぶか、先にバイトオーダーマークを追加してください。スプレッドシートと LibreOffice はどちらの場合も正しく扱います。`)
};

/**
* | output |
* | --- |
* | "The output is UTF-8 with no byte order mark. Double clicking the file on Windows makes Excel guess the system code page, which corrupts accented and CJK char..." |
*
* @param {To_Csv_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_pit3_d = /** @type {((inputs?: To_Csv_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_pit3_d(inputs)
	if (locale === "ko") return ko_to_csv_pit3_d(inputs)
	return ja_to_csv_pit3_d(inputs)
});